import React, { FC, CSSProperties } from "react";
import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import classes from "./DndItems.module.scss";
import { Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from "@mui/icons-material";
import { colorSelectRuturnCode } from "../../commons/columnColor";
import { useRecoilValue } from "recoil";
import { userState } from "../../states/userState";
type Props = {
  onClick: () => void;
  id: string;
  column: { [key: string]: boolean };
};

const DndItems: FC<Props> = (props) => {
  const { onClick, id, column } = props;
  const user = useRecoilValue(userState);
  // const { id, column } = props;
  // const { id } = props;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });
  const colorCode = colorSelectRuturnCode(id);
  const dndStyleBase = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: "none",
    // margin: '0 0 8px 0', // アイテム間のマージン
    // boxShadow: isDragging ? "0px 0px 15px rgba(0,0,0,0.2)" : "none", // ドラッグ中は影を追加
    scale: isDragging ? 1.05 : 1, // ドラッグ中は少し大きくする
    color: column[id] ? colorCode : "#202226",
    // color: colorCode,
    border: !column[id] ? `3px solid ${colorCode}` : "inherit",
    // color: colorCode,
  };
  return (
    <div
      ref={setNodeRef}
      className={
        isDragging
          ? user?.mode === "lite"
            ? classes.contentBodyDraggingLite
            : classes.contentBodyDragging
          : column[id]
          ? user?.mode === "lite"
            ? classes.contentBodyLite
            : classes.contentBody
          : user?.mode === "lite"
          ? classes.contentBodyOffLite
          : classes.contentBodyOff
      }
      // className={classes.contentBody}
      style={dndStyleBase}
      {...attributes}
      {...listeners}
      onClick={onClick}
    >
      <div>{id.split("_")[1]}</div>
      {/* <div>{id}</div> */}
      <div>
        {column[id] ? (
          <VisibilityIcon
            sx={{ color: colorCode, width: { xs: "16px", sm: "20px" } }}
          />
        ) : (
          <VisibilityOffIcon
            sx={{ color: "#202226", width: { xs: "16px", sm: "20px" } }}
          />
        )}
      </div>
    </div>
  );
};

export default DndItems;
